module.exports = __webpack_public_path__ + "img/individual_nationality.6e94d00e.svg";